<script lang="ts">
    import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, TabContent, TabPane } from "sveltestrap";
    import { BasicTabs, BasicTabsContent, BasicTabsContent1, BasicTabsContent2 } from "../../../../utils/Constant/Constant";
    import Card from "../../UiCommenCard.svelte";
</script>
<Col sm="12" xl="6" class="xl-100">
    <Card cardHeaderprops="pb-0" headerTitle={BasicTabs}>
      <div slot="contentbody">
        <TabContent>
            <TabPane tabId="Home" tab="Home" active>
                <p class="mb-0 m-t-30">{BasicTabsContent}</p>
            </TabPane>
            <Dropdown class="tab-pane">
                <DropdownToggle caret>Dropdown</DropdownToggle>
                <DropdownMenu>
                    <DropdownItem>Action</DropdownItem>
                    <DropdownItem>Another action</DropdownItem>
                    <DropdownItem>Something else here</DropdownItem>
                    <DropdownItem>Separated link</DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <TabPane tabId="Profile" tab="Profile">
                <p class="mb-0 m-t-30">{BasicTabsContent1}</p>
            </TabPane>
            <TabPane tabId="Contact" tab="Contact">
                <p class="mb-0 m-t-30">{BasicTabsContent2}</p>
            </TabPane>
          </TabContent>
      </div>
    </Card>
</Col>